import { render, staticRenderFns } from "./exit-screen-settings.vue?vue&type=template&id=93820112&scoped=true&"
import script from "./exit-screen-settings.vue?vue&type=script&lang=js&"
export * from "./exit-screen-settings.vue?vue&type=script&lang=js&"
import style0 from "./exit-screen-settings.vue?vue&type=style&index=0&id=93820112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93820112",
  null
  
)

export default component.exports